import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// @material-ui/icons
import FlightTakeoffIcon from "@material-ui/icons/FlightTakeoff";
import AlarmIcon from "@material-ui/icons/Alarm";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Card from "components/Card/Card.jsx";
import CardHeader from "components/Card/CardHeader.jsx";
import DomainTitle from "components/DomainTitle/DomainTitle.jsx";

import Avatar from "@material-ui/core/Avatar";
import List from "@material-ui/core/List";
import ListItem from "@material-ui/core/ListItem";
import ListItemText from "@material-ui/core/ListItemText";
import courseDetailsStyle from "assets/jss/material-kit-pro-react/views/sectionsSections/courseDetailsStyle.jsx";

function CourseDetailsSection({ ...props }) {

  console.log("props", props);
  const { classes, course, ...rest } = props;
  const images = require.context("../../../assets/img/courses", true);

  if (!course) {
    return null;
  }
  const image = images(`./${course.id}.png`);

  return (
    <div className="cd-section" {...rest}>
      {/* Blogs 3 START */}
      <div className={classes.blog}>
        <div className={classes.container}>
          <GridContainer>
            <Card plain blog className={classes.card}>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <CardHeader image plain>
                    <img src={image} alt="..." />
                    <div
                      className={classes.coloredShadow}
                      style={{
                        backgroundImage: `url(${image})`,
                        opacity: "1"
                      }}
                    />
                  </CardHeader>
                </GridItem>
              </GridContainer>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <GridContainer justify="center">
                    <GridItem xs={12} sm={6} md={5} lg={4}>
                      <List className={classes.list} dense="true">
                        <ListItem>
                          <Avatar>
                            <CalendarTodayIcon />
                          </Avatar>
                          <ListItemText
                            primary="Total time"
                            secondary="3 hours"
                          />
                        </ListItem>
                      </List>
                    </GridItem>
                    <GridItem xs={12} sm={6} md={5} lg={4}>
                      <List className={classes.list} dense="true">
                        <ListItem>
                          <Avatar>
                            <AlarmIcon />
                          </Avatar>
                          <ListItemText
                            primary="Weeks to complete"
                            secondary="2 weeks"
                          />
                        </ListItem>
                      </List>
                    </GridItem>
                  </GridContainer>
                </GridItem>
              </GridContainer>
              <GridContainer justify="center">
                <GridItem xs={12} sm={12} md={8}>
                  <DomainTitle
                    domainId={course.id.split("_").shift()}
                    domainName={course.domain}
                  />
                  <h3 className={classes.cardTitle}>{course.name}</h3>
                  <p className={classes.courseDescription}>{course.desc}</p>
                  <p className={classes.courseDescription}>
                    *Please note: These modules are available to Navitas staff
                    only.
                  </p>
                </GridItem>
              </GridContainer>
            </Card>
          </GridContainer>
        </div>
      </div>
      {/* Blogs 3 END */}
    </div>
  );
}

export default withStyles(courseDetailsStyle)(CourseDetailsSection);
